import { useDispatch, useSelector } from 'react-redux'
import RaytebModal from './RaytebModal'
import { ReducerType } from '../../../storeManager/ReducerType'
import { CenterConfigEnum } from '../../../enums/CenterConfig'
import { Button, RaytebForm, TextBox } from '../../Elements'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { useState, useEffect } from 'react'
import { setQueueRoom } from '../../../storeManager/Reducers/queueSlice'
import { toast } from 'react-toastify'

const QueueInfoModal = ({
  open,
  hideModal,
}: {
  open?: boolean
  hideModal?: () => void
}) => {
  const queue = useSelector<ReducerType, QueueViewModel>(
    (state) => state.reducerQueue
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const [showQueueModal, setQueueModal] = useState<boolean>(false)

  const dispatch = useDispatch()

  useEffect(() => {
    setQueueModal(open ?? false)
  }, [open])
  useEffect(() => {
    if (
      center.centerConfigs?.find((n) => n.key === CenterConfigEnum.Queue)
        ?.value === 'True' &&
      (!queue.roomNo || queue.roomNo === 0)
    ) {
      setQueueModal(true)
    }
  }, [center.centerConfigs, center.id, queue.roomNo])
  return (
    <RaytebModal
      isOpen={showQueueModal}
      title='اطلاعات صف'
      hideModal={() => {
        setQueueModal(false)
        hideModal?.()
      }}
    >
      <RaytebForm
        className='p-2 flex justify-center items-center flex-col gap-3'
        checkIsRequired={true}
        onSubmit={(e) => {
          dispatch(setQueueRoom(e.target['roomNo'].value))
          setQueueModal(false)
          hideModal?.()
          toast.success('ثبت شد')
        }}
      >
        <div className='w-40 py-5'>
          <TextBox
            autoFocus={true}
            Type={TextBoxTypeEnum.Number}
            innerText='شماره اتاق'
            isRequired={true}
            value={queue.roomNo?.toString()}
            name='roomNo'
          />
        </div>
        <p className='text-xs text-primary font-bold'>
          {`پزشک محترم لطفا شماره اتاق خود را در مرکز "${center.name}" ثبت کنید`}
        </p>
        <div className='mt-2 flex justify-center items-center  gap-5 w-full px-8 pb-2'>
          <Button
            onClick={() => {
              setQueueModal(false)
              hideModal?.()
            }}
            className='!border-2 !px-7 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
          >
            انصراف
          </Button>
          <Button
            type='submit'
            className='!border-2 border-secondaryLight !px-9 !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
          >
            تایید
          </Button>
        </div>
      </RaytebForm>
    </RaytebModal>
  )
}

export default QueueInfoModal
